module.exports = __webpack_public_path__ + "img/文档.6f7506c0.png";